import React from "react";
import {formatOnlyDateRange} from "../../utils/commonFunction";
import { GetCampusText, GetLearningMethodText } from "./ProgramHelperUtils.js";
import { ProgramHead, ProgramInfoRow } from "./ProgramStyledComponents.js";

const ProgramHeadBox = (props) => {
  const row = props.content; 

  const dateItems = [
    row?.start && row?.end
      ? formatOnlyDateRange(row.start, row.end)
      : null,

    row?.number && row?.year
      ? `Intake ${row.number}, ${row.year}`
      : null,
  ].filter(Boolean);

  const hasDateGroup = dateItems.length > 0;
  const hasType = !!row?.type;
  const hasLocation = !!row?.campus;
  const hasLocationGroup = hasType || hasLocation;
  const typeLocationText =
    [
      row?.type ? GetLearningMethodText(row.type) : null,
      row?.campus ? GetCampusText(row.campus) : null,
    ]
      .filter(Boolean)
      .join(" - ");

  return (
    <div>
      <ProgramHead title={row.course}>
        {row.course}
      </ProgramHead>
      <ProgramInfoRow>
        {hasDateGroup && (
          <>
            <i
              className="fa-light fa-calendar-clock"
              style={{ marginRight: "4px" }}
            />
            {dateItems.join(" | ")}
          </>
        )}
        {hasDateGroup && hasLocationGroup && " | "}
        {hasLocationGroup && (
          <>
            <i
              className="fa-light fa-building-columns"
              style={{ marginLeft: "4px", marginRight: "4px" }}
            />
            {typeLocationText}
          </>
        )}
      </ProgramInfoRow>
    </div>
  );
}
export default ProgramHeadBox;
